const hours = [
  { label: "1 Hour", value: "1hr" },
  { label: "2 Hours", value: "2hrs" },
  { label: "3 Hours", value: "3hrs" },
  { label: "4 Hours", value: "4hrs" },
  { label: "5 Hours", value: "5hrs" },
  { label: "6 Hours", value: "6hrs" },
  { label: "7 Hours", value: "7hrs" },
];

const timeOptions = [
  { label: "1AM", value: "01:00" },
  { label: "2AM", value: "02:00" },
  { label: "3AM", value: "03:00" },
  { label: "4AM", value: "04:00" },
  { label: "5AM", value: "05:00" },
  { label: "6AM", value: "06:00" },
  { label: "7AM", value: "07:00" },
  { label: "8AM", value: "08:00" },
  { label: "9AM", value: "09:00" },
  { label: "10AM", value: "10:00" },
  { label: "11AM", value: "11:00" },
  { label: "12PM", value: "12:00" },
  { label: "1PM", value: "13:00" },
  { label: "2PM", value: "14:00" },
  { label: "3PM", value: "15:00" },
  { label: "4PM", value: "16:00" },
  { label: "5PM", value: "17:00" },
  { label: "6PM", value: "18:00" },
  { label: "7PM", value: "19:00" },
  { label: "8PM", value: "20:00" },
  { label: "9PM", value: "21:00" },
  { label: "10PM", value: "22:00" },
  { label: "11PM", value: "23:00" },
  { label: "12AM", value: "24:00" },
];

const timezones = [
  { label: "GMT-12:00", value: "GMT-12:00" },
  { label: "GMT-11:00", value: "GMT-11:00" },
  { label: "GMT-10:00", value: "GMT-10:00" },
  { label: "GMT-09:30", value: "GMT-09:30" },
  { label: "GMT-09:00", value: "GMT-09:00" },
  { label: "GMT-08:00", value: "GMT-08:00" },
  { label: "GMT-07:00", value: "GMT-07:00" },
  { label: "GMT-06:00", value: "GMT-06:00" },
  { label: "GMT-05:00", value: "GMT-05:00" },
  { label: "GMT-04:00", value: "GMT-04:00" },
  { label: "GMT-03:30", value: "GMT-03:30" },
  { label: "GMT-03:00", value: "GMT-03:00" },
  { label: "GMT-02:00", value: "GMT-02:00" },
  { label: "GMT-01:00", value: "GMT-01:00" },
  { label: "GMT±00:00", value: "GMT±00:00" },
  { label: "GMT+01:00", value: "GMT+01:00" },
  { label: "GMT+02:00", value: "GMT+02:00" },
  { label: "GMT+03:00", value: "GMT+03:00" },
  { label: "GMT+03:30", value: "GMT+03:30" },
  { label: "GMT+04:00", value: "GMT+04:00" },
  { label: "GMT+04:30", value: "GMT+04:30" },
  { label: "GMT+05:00", value: "GMT+05:00" },
  { label: "GMT+05:30", value: "GMT+05:30" },
  { label: "GMT+05:45", value: "GMT+05:45" },
  { label: "GMT+06:00", value: "GMT+06:00" },
  { label: "GMT+06:30", value: "GMT+06:30" },
  { label: "GMT+07:00", value: "GMT+07:00" },
  { label: "GMT+08:00", value: "GMT+08:00" },
  { label: "GMT+08:45", value: "GMT+08:45" },
  { label: "GMT+09:00", value: "GMT+09:00" },
  { label: "GMT+09:30", value: "GMT+09:30" },
  { label: "GMT+10:00", value: "GMT+10:00" },
  { label: "GMT+10:30", value: "GMT+10:30" },
  { label: "GMT+11:00", value: "GMT+11:00" },
  { label: "GMT+12:00", value: "GMT+12:00" },
  { label: "GMT+12:45", value: "GMT+12:45" },
  { label: "GMT+13:00", value: "GMT+13:00" },
  { label: "GMT+14:00", value: "GMT+14:00" },
];

export { hours, timeOptions, timezones };
